import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { PositionType, UitkMenu, UitkMenuContainer, UitkMenuTrigger } from 'uitk-react-menu';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkLink, UitkLinkAlign } from 'uitk-react-link';

export interface PriceBreakDownMenuProps {
  id: string;
  childContent: React.ReactNode;
  header: string;
  layerId: string | number;
  roomName?: string;
}

const LinkTracked = ClickTracker(UitkLink);

export const PriceBreakDownMenu = ({ childContent, id, header, layerId, roomName }: PriceBreakDownMenuProps) => {
  const [showMenu, setShowMenu] = React.useState<boolean>(false);
  const handleClick = () => setShowMenu(!showMenu);

  if (!header || !childContent) {
    return null;
  }

  const trackingRfrr = id === 'infosite-room-ratePlans' ? 'RoomsAndRates.PriceDetail' : 'RoomInfo.PriceDetail';

  return (
    <UitkMenu id={`pricebreakdown-menu-${layerId}`} isOpen={showMenu} onTriggerClick={handleClick} className="price-details">
      <UitkMenuTrigger>
        <LinkTracked linkName="price.breakdown.details" rfrr={trackingRfrr} iconPos={UitkLinkAlign.RIGHT}>
          <button>
            {header}
            {roomName && <span className="is-visually-hidden">{roomName}</span>}
            <UitkIcon name="expand_more" size={UitkIconSize.SMALL} />
          </button>
        </LinkTracked>
      </UitkMenuTrigger>
      <UitkMenuContainer width={275} position={PositionType.RIGHT}>
        {childContent}
      </UitkMenuContainer>
    </UitkMenu>
  );
};

PriceBreakDownMenu.displayName = 'PriceBreakDownMenu';
